import { gsap } from 'gsap';
const homepageHero = document.getElementById('homepage-hero');
const headerVideo = document.getElementById('headerVideo');

function initializeHomepageHero() {
    if (homepageHero) {
        const tl = gsap.timeline();

        // First set
        tl.to('.first', { opacity: 1, duration: 0.5, delay: 1 });

        // Second set
        tl.to('.second', { opacity: 1, duration: 0.5, delay: 3 });

        // Third set
        tl.to('.third', { opacity: 1, duration: 0.5, delay: 3 });

        // Fifth + sixth set
        tl.to('.fifth', { opacity: 1, duration: 0, delay: 2 });
        tl.to('.sixth', { opacity: 1, duration: 0, delay: 0 });

        tl.to('.first', { opacity: 0, duration: 0.5, delay: 3 });
        tl.to('.second', { opacity: 0, duration: 0.5, delay: 0 });
        tl.to('.third', { opacity: 0, duration: 0.5, delay: 0 });


        tl.to('.fifth', { opacity: 0, duration: 0.5, delay: 0 });
        tl.to('.sixth', { opacity: 0, duration: 0.5 }, '<');

        headerVideo.addEventListener('play', () => {
            tl.restart();
        });

        headerVideo.addEventListener('ended', () => {
            headerVideo.play();
        });

        headerVideo.play();
    }
}

export { initializeHomepageHero };
